import { o_global } from "@gr-common/head/namespaces";
import { assignNamespace } from "@gr-common/head/namespace-utils";
import {
  activate,
  activateLegacy,
  setColors,
  deactivate,
  logger,
  scope,
  updateWriter,
  warn,
  setLevel,
} from "./debug.js";
import { Level } from "./level.js";
import { status, updateStatus } from "./status.js";
import { readCookies } from "./cookie.js";

/**
 *
 */
export type GlobalDebug = {
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  logger: typeof logger;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  scope: typeof scope;

  /**
 *
 */
  Level: typeof Level;

  /**
 *
 */
  status: typeof status;

  /**
 *
 */
  setColors: typeof setColors;

  /**
 *
 */
  setLevel: typeof setLevel;
};

/*                            */
updateWriter(updateStatus(readCookies()));

/*                                              */
assignNamespace(o_global, "debug", {
  /*                               */
  activate,
  deactivate,
  logger,
  scope,
  Level,
  status,
  warn,
  setColors,
  setLevel,
  activateLegacy,
});

/*                                                       */
otto.debug.assignNamespace(
  {
    /*                                                            */
    sendLog: (namespace, data) => window.AS.RUM?.sendCustomRequest(namespace, data),
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);
